// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"3ff986c4","42":"f745b3d6","205":"3ff986c4"}[chunkId] + ".chunk.css";
};